// Vendor
import { gsap, CSSPlugin } from 'gsap';
/* eslint-disable */
import LazySizes from 'lazysizes';
import Unveilhooks from 'lazysizes/plugins/unveilhooks/ls.unveilhooks';
/* eslint-enable */

// Components
import Menu from './components/menu';
import PrimaryNav from './components/primary-nav';
import CanvasCircles from './components/canvas-circles';
import Cursor from './components/cursor';
import Links from './components/links';
import Highlighter from './components/highlighter';
import PathwayScroller from './components/pathway-scroller';
import PromoClose from './components/promo-close';
import Slider from './components/slider';
import Tabs from './components/tabs';
import TreeNav from './components/tree-nav';
import Accordion from './components/accordion';
import Modals from './components/modals';

// Algolia components
import searchClient from './algolia/searchClient';
import AlgoliaNavSearch from './algolia/nav-search';
import AlgoliaGlobalSearch from './algolia/global-search';
import AlgoliaPeopleSearch from './algolia/people-search';
import AlgoliaPathwaysSearch from './algolia/pathways-search';
import AlgoliaProjectsSearch from './algolia/projects-search';
import AlgoliaResourcesSearch from './algolia/resources-search';
import AlgoliaPostsSearch from './algolia/posts-search';

document.addEventListener('DOMContentLoaded', () => {
  gsap.registerPlugin(CSSPlugin);

  new Links();

  // This is an example of how to do code splitting. The JS in this
  // referenced file will only be loaded on that page. Good for
  // when you have a large amount of JS only needed in one place
  /*
  if (document.querySelector('#js-process')) {
    require.ensure(
      ['./pages/process'],
      require => {
        const Process = require('./pages/process').default;
        this.process = new Process();
      },
      'process'
    );
  }
  */

  if (document.querySelector('.js--toc')) {
    new Menu('.js--toc');
  }

  if (document.querySelector('.js--menu')) {
    new Menu('.js--menu');
  }

  if (document.querySelector('.js--primary-nav')) {
    new PrimaryNav();
  }

  if (document.querySelector('.js--cursor')) {
    new Cursor();
  }

  if (document.querySelector('.js--slider')) {
    new Slider();
  }

  if (document.querySelector('.js--pathway-scroller')) {
    new PathwayScroller();
  }

  if (document.querySelector('.js--highlighter')) {
    new Highlighter();
  }

  if (document.querySelector('.js--canvas-circles')) {
    new CanvasCircles();
  }

  if (document.querySelector('.js--tabs')) {
    new Tabs();
  }

  if (document.querySelector('.js--tree-nav')) {
    new TreeNav();
  }

  if (document.querySelector('.js--accordion')) {
    new Accordion();
  }

  if (document.querySelector('.js--modal')) {
    new Modals();
  }

  if (document.querySelector('.js--promo-close')) {
    new PromoClose();
  }

  // Algolia
  if (searchClient) {
    const globalIndexName = `${window.cssh.env.ALGOLIA_INDEX_PREFIX}global_search`;
    const peopleIndexName = `${window.cssh.env.ALGOLIA_INDEX_PREFIX}people_search`;

    if (document.querySelector('.js--nav-search')) {
      new AlgoliaNavSearch(globalIndexName);
    }

    if (document.querySelector('.js--global-search')) {
      new AlgoliaGlobalSearch(globalIndexName);
    }

    if (document.querySelector('.js--resources-search')) {
      new AlgoliaResourcesSearch(globalIndexName);
    }

    if (document.querySelector('.js--people-search')) {
      const peopleSearchEl = document.querySelector('.js--people-search');
      const department = peopleSearchEl.dataset.department;
      const researchCenter = peopleSearchEl.dataset.researchCenter;

      new AlgoliaPeopleSearch(peopleIndexName, department, researchCenter);
    }

    if (document.querySelector('.js--pathways-search')) {
      const pathwaysSearchEl = document.querySelector('.js--pathways-search');
      const department = pathwaysSearchEl.dataset.department;
      const researchCenter = pathwaysSearchEl.dataset.researchCenter;
      const degree = pathwaysSearchEl.dataset.degree;
      const studentType = pathwaysSearchEl.dataset.studentType;

      new AlgoliaPathwaysSearch(peopleIndexName, department, researchCenter, degree, studentType);
    }

    if (document.querySelector('.js--projects-search')) {
      const projectsSearchEl = document.querySelector('.js--projects-search');
      const department = projectsSearchEl.dataset.department;
      const researchCenter = projectsSearchEl.dataset.researchCenter;

      new AlgoliaProjectsSearch(globalIndexName, department, researchCenter);
    }

    if (document.querySelector('.js--posts-search')) {
      const postsSearchEl = document.querySelector('.js--posts-search');
      const department = postsSearchEl.dataset.department;
      const researchCenter = postsSearchEl.dataset.researchCenter;
      const category = postsSearchEl.dataset.category;
      const tags = postsSearchEl.dataset.tags;

      new AlgoliaPostsSearch(globalIndexName, department, researchCenter, category, tags);
    }
  }
});
